import styled from 'styled-components';


const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  @media (min-width: 768px) {
    max-width: 750px;
  }
  @media (min-width: 992px) {
    max-width: 970px;
  }
  @media (min-width: 1260px) {
    max-width:980px;
  }
  a {
    font-size: 14px;
    margin-bottom: 16px;
  }
`;
const SubTitle = styled.h1`
  padding-top: 60px;
  padding-bottom: ${({ bottom = 30 }) => `${bottom}px`};
  margin-bottom: 0;
  line-height: 43px;
  font-size: 34px;
  font-weight: 600;
  color: #212833 !important;
  font-family: ${({ theme }) => theme.fontIBMSemiBold};
`;

const Details = styled.div`
  ${({ hasMarginTop }) => (hasMarginTop ? 'margin-top:30px;' : null)};
  ${({ hasMarginTopTow }) => (hasMarginTopTow ? 'margin-top:40px;' : null)};
  ${({ hasFontWeight }) => (hasFontWeight ? 'font-weight: bold;' : null)};
  ${({ hasColor }) => (hasColor ? 'color: #212833;' : 'color: #48515d;')};
  font-family: ${({ hasFontFamily, theme }) => (hasFontFamily ? theme.fontIBMMedium : theme.fontIBMRegular)};
  ${({ hasMarginBottom }) => (hasMarginBottom ? 'margin-bottom: 200px;' : 'margin-bottom: 24px;')};
  font-size:14px;
  line-height:24px;
  & a{
    color:#F0B90B;
  }
  & a:hover{text-decoration: underline;}
  & span{
    font-weight: bold;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    color: #212833;
  }
  ul {
    margin-left: 32px;
    li {
      margin-bottom: 4px;
      ol {
        list-style-type: circle;
      }
    }
  }
  .ml32 {
    margin-left: 32px;
  }
`;


const SubtitleTow = styled.h1`
    ${({ hasFontSize }) => (hasFontSize ? 'font-size:16px;' : 'font-size:14px;')}
    font-weight: bold;
    color: #212833 !important;
    font-family: ${({ theme }) => theme.fontIBMMedium};
    line-height:24px;
    margin-bottom: 24px;
`;
const Eggshell = styled.div`
    color: #48515d;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    line-height: 24px;
    ${({ hasMarginBottom }) => (hasMarginBottom ? 'margin-bottom: 200px;' : 'margin-bottom: 24px;')}
    & >ol{
      list-style: lower-roman;
    }
    & >ol>li{
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 10px;
        &.cornerMarginTop{
          margin-top:10px;
        }
      }
    & >ul{
      list-style: disc;
    }
    & >ul>li{
      font-size: 14px;
      line-height: 24px;
      margin-left:40px;
      margin-bottom: 10px;
      &.cornerMarginTop{
        margin-top:10px;
      }
    }
`;

const LinkTag = styled.a`
  color: #F0B90B;
  &:hover {
    color: #F0B90B;
    text-decoration: underline;
  }
`;

const Anchor = styled.div`
  position: relative;
  bottom: 64px;
`;

export {
  Container,
  SubTitle,
  Details,
  SubtitleTow,
  Eggshell,
  LinkTag,
  Anchor
};
